import React from 'react'
import HeadTitle from '../../../../head-title/head-title'

const PupilTitle = ({ classes, name }) => <HeadTitle>{name}</HeadTitle>

export default PupilTitle
